import { IParamsByUrl, ISelectedFilters } from '~types/search'

const getSelectedFilters = (params: IParamsByUrl): ISelectedFilters => {
  const {
    categories,
    brands,
    priceRanges,
    tags,
    availablePromotions,
    operationalModels,
  } = params

  return {
    categories,
    brands,
    priceRanges,
    tags,
    availablePromotions,
    operationalModels,
  }
}

export default getSelectedFilters
